define('models/calendar/nutrition/entry-tag',[
    'underscore', 'backbone', 'utils',
    // services
    'services/api'
], function(_, Backbone, U, API) {

    var MEntryTag = Backbone.Model.extend({
        idAttribute: 'tag',
        urlRoot: API.url("nutrition/tags"),
    });

    return MEntryTag;
});

